import { IllustrationSize } from "@/constants/UI";
import { MaxHeight } from "@/ui/components/home/UpcomingEventCard";
import { EmptyListBaseCard } from "@/ui/layout";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const EmptyUpcomingEventsCard = ({ testID }: ViewWithTestID) => {
  return (
    <EmptyListBaseCard
      description="Scheduled appointments will appear here."
      iconHeight={IllustrationSize.UpcomingEvents}
      iconName={IllustrationName.Exclamation}
      iconWidth={IllustrationSize.UpcomingEvents}
      isCentered
      maxHeight={MaxHeight}
      testID={testID}
      title="No upcoming events"
    />
  );
};

export default EmptyUpcomingEventsCard;
